import { useState } from 'react'
import Snippet from '../../components/Snippet/Snippet'
import { modal } from '../../assets/code-snippets/modal/snip'

const Modal = () => {

    const [showModal, setShowModal] = useState(false)

    const toggle = () => {
        setShowModal(prev => !prev)
    }

    return <div className="container xl py-3">

        {showModal && <div className="modal active top1">
            <div className="content">
                <div className="header">
                    <span>Modal title</span>
                    <div className="close" id="modal-close" onClick={toggle}>x</div>
                </div>
                <div className="body">
                    <Snippet code={modal} language='html' />
                </div>
                <div className="footer">
                    <span>Modal footer</span>
                </div>
            </div>
        </div>}


        <div className="container fluid py-2" id="intro">
            <div className="container fluid">
                <p className="text xl"><a href="#intro" className="link">&#128279;</a> Modal </p>
                <p className="text md">Modal is an overlaying element which pops up only when user creates a DOM event, such as clicking a button, and which contains pieces of information which we want user to read. </p>
                <button onClick={toggle} className="btn lg info outline">Click! to open modal shown</button>
            </div>
        </div>

        <div className="container fluid">
            <div className="table" padding="2" cell-spacing="3" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Main</th>
                            <th>Additional</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top0</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 0</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top1</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 1%</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top5</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 5%</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top10</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 10%</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top15</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 15%</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.top20</code>
                            </td>
                            <td>Sets the <code>margin-top</code> to 20%</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.sm</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 576px</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.md</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 768px</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.lg</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 992px</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.xl</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 1200px</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.xxl</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 1400px</td>
                        </tr>
                        <tr>
                            <td><code>.modal</code></td>
                            <td><code>.fluid</code>
                            </td>
                            <td>Sets the <code>max-width</code> to 100% - 20px</td>
                        </tr>
                        <tr>
                            <td><code className='text bold danger'>body</code></td>
                            <td><code>.modal-active</code>
                            </td>
                            <td>Will set <code>overflow-y: hidden</code> to body element</td>
                        </tr>
                        <tr>
                            <td><code className='text bold danger'>.modal</code></td>
                            <td><code className='text bold success'>.scroll</code>
                            </td>
                            <td>Will set <code>overflow-y: auto</code> to modal element</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

    </div>

}

export default Modal